<sh-card columns="12">
  <sh-text size="header-2" color="primary">
    {{ 'label.serviceTickets' | translate }}
    <span style="font-weight: 100">{{ ticketCountDisplay$ | async }}</span>
  </sh-text>
  <api-call-gate
    [apiCall]="serviceTicketsService.getTickets"
    loadingLabel="loading tickets.."
  >
    <ng-template #lastSuccessfulData>
      <ng-container
        *ngTemplateOutlet="tickets; context: { $implicit: topTickets$ | async }"
      ></ng-container>
    </ng-template>
  </api-call-gate>
</sh-card>

<!-- ticket rendering -->
<ng-template #tickets let-topTickets>
  <ng-container *ngIf="topTickets?.length === 0">
    <div class="empty">
      <sh-icon icon="list-viewmode" disabled style="margin: auto"></sh-icon>
      <br />
      No service tickets found
    </div>
  </ng-container>
  <ng-container *ngIf="topTickets?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        (screenLayoutService.desktopAny$ | async)
          ? ticketsDesktop
          : ticketsMobile;
        context: { $implicit: topTickets$ | async }
      "
    ></ng-container>
    <sh-button
      color="secondary"
      size="auto"
      (click)="loadDetailedView()"
      label="All Service Tickets"
      id="target-tickets"
    ></sh-button>
  </ng-container>
</ng-template>

<!-- tickets: table version (desktop) -->
<ng-template #ticketsDesktop let-topTickets>
  <sh-table>
    <sh-table-row slot="header">
      <sh-table-head unsortable columns="7">{{
        'label.creationDate' | translate
      }}</sh-table-head>
      <sh-table-head unsortable columns="11"
        >{{ 'label.ticketNumber' | translate }}
      </sh-table-head>
      <sh-table-head unsortable columns="10">{{
        'label.description' | translate
      }}</sh-table-head>
      <sh-table-head unsortable columns="9"
        >{{ 'label.Ticketstatus' | translate }}
      </sh-table-head>
    </sh-table-row>
    <sh-table-row *ngFor="let ticket of topTickets" t_ticket>
      <sh-table-cell
        style="height: auto"
        class="ticket-indicator"
        [attr.color]="ticket.statusColor"
        columns="7"
      >
        <sh-text>{{ ticket.creationDate | localizedDate }}</sh-text>
        <sh-badge
          *ngIf="ticket.status === 'Closed'"
          style="margin-top: 3px"
          label="{{ ticket.status }}"
        ></sh-badge>
      </sh-table-cell>
      <sh-table-cell columns="11">
        <span> {{ ticket.ticketNumber }} </span>
        <sh-icon
          id="copyToClipboard"
          style="cursor: pointer; align-items: baseline; height: auto"
          (click)="clipboard.copyToClipboard(ticket.ticketNumber)"
          icon="copy-results-to-clipboard"
          aria-label="Copy results to clipboard"
          button
          size="s"
        ></sh-icon>
        <sh-tooltip
          label="Copy to Clipboard"
          target="copyToClipboard"
          placement="top"
          variation="short"
        ></sh-tooltip>
      </sh-table-cell>
      <sh-table-cell columns="10">
        <sh-text id="description" #description class="linebreak">
          {{ ticket.description }}</sh-text
        >
        <ng-container *ngIf="isOverflowing(description)">
          <sh-tooltip
            label="{{ ticket.description }}"
            target="description"
            placement="top"
            variation="short"
          ></sh-tooltip>
        </ng-container>
      </sh-table-cell>
      <sh-table-cell columns="9">
        <sh-text>{{
          ticket.operationalState ? ticket.operationalState : 'Unknown'
        }}</sh-text>
      </sh-table-cell>
    </sh-table-row>
  </sh-table>
</ng-template>

<!-- tickets: mobile version (phone & tablet) -->
<ng-template #ticketsMobile let-topTickets>
  <div class="tickets-mobile">
    <div
      t_ticket
      class="ticket"
      *ngFor="let ticket of topTickets"
      [attr.color]="ticket.statusColor"
    >
      <div class="item">
        <sh-text size="body-2" color="secondary">{{
          'label.creationDate' | translate
        }}</sh-text>
        <span>{{ ticket.creationDate | localizedDate }}</span>
        <sh-badge
          *ngIf="ticket.status === 'Closed'"
          label="{{ ticket.status }}"
          style="margin-top: 3px"
        ></sh-badge>
      </div>
      <div class="item">
        <sh-text size="body-2" color="secondary">{{
          'label.ticketNumber' | translate
        }}</sh-text>
        <span style="display: flex; white-space: nowrap"
          >{{ ticket.ticketNumber }}

          <sh-icon
            id="copyToClipboard"
            style="
              cursor: pointer;
              align-items: baseline;
              margin-top: -0.25rem;
              margin-left: 0.5rem;
              display: inline;
            "
            (click)="clipboard.copyToClipboard(ticket.ticketNumber)"
            icon="copy-results-to-clipboard"
            aria-label="Copy results to clipboard"
            button
            size="s"
          ></sh-icon>
        </span>
      </div>
      <div class="item" style="width: 100%">
        <sh-text size="body-2" color="secondary">{{
          'label.description' | translate
        }}</sh-text>
        <span>{{ ticket.description }}</span>
      </div>
      <div class="item">
        <sh-text size="body-2" color="secondary">{{
          'label.TicketstatusFN' | translate
        }}</sh-text>
        <span>{{
          ticket.operationalState ? ticket.operationalState : 'Unknown'
        }}</span>
      </div>
    </div>
  </div>
</ng-template>
